const legendItems = [
  { name: 'Strength', style: '' },
  { name: 'Weakness', style: 'weakness' },
  { name: 'Opportunity', style: 'opportunity' },
  { name: 'Threat', style: 'threat' },
];

export default legendItems;
